export enum Direction {
  Unspecified = -1,
  DepartmentToDepartment = 0,
  DepartmentToAddress = 10,
  AddressToDepartment = 20,
  AddressToAddress = 30,
}
